module.exports = __webpack_public_path__ + "img/gates-of-olympus.8cca70bb.png";